import { render, staticRenderFns } from "./sectionM4.vue?vue&type=template&id=2d54d065&scoped=true&"
import script from "./sectionM4.vue?vue&type=script&lang=js&"
export * from "./sectionM4.vue?vue&type=script&lang=js&"
import style0 from "./sectionM4.vue?vue&type=style&index=0&id=2d54d065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54d065",
  null
  
)

export default component.exports